var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"office"},[(_vm.judgePics(_vm.url))?_c('img',{staticClass:"preview-img",attrs:{"src":_vm.url,"alt":""}}):_c('iframe',{attrs:{"src":_vm.url ? _vm.base + _vm.url : '',"width":"100%","height":"800px","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }